import {
  CompositeFilterDescriptor,
  FilterOperator,
} from '@progress/kendo-data-query';
import moment from 'moment';
import { StatisticsFilterModel } from '../../../models/StatisticsFilterModel';

const dateIntervalValues: {
  [key: number]: { dateStart?: Date; dateEnd?: Date };
} = {
  [0]: {
    dateStart: moment().subtract(30, 'days').startOf('day').toDate(),
    dateEnd: moment().endOf('day').toDate(),
  },
  [1]: {
    dateStart: moment().subtract(90, 'days').startOf('day').toDate(),
    dateEnd: moment().endOf('day').toDate(),
  },
  [2]: {
    dateStart: moment().subtract(1, 'month').startOf('month').toDate(),
    dateEnd: moment().subtract(1, 'month').endOf('month').toDate(),
  },
  [3]: {
    dateStart: moment().subtract(12, 'months').startOf('day').toDate(),
    dateEnd: moment().endOf('day').toDate(),
  },
  [4]: {
    dateStart: moment().subtract(1, 'year').startOf('year').toDate(),
    dateEnd: moment().subtract(1, 'year').endOf('year').toDate(),
  },
  [5]: {
    dateStart: moment().startOf('year').toDate(),
    dateEnd: moment().endOf('day').toDate(),
  },
  [6]: { dateStart: undefined, dateEnd: undefined },
};

export const getDateIntervalValue = (key: number) => {
  const value = dateIntervalValues[key];

  return value;
};

export const getFilter = (
  filterData: StatisticsFilterModel,
): CompositeFilterDescriptor => {
  const filter: CompositeFilterDescriptor = { logic: 'and', filters: [] };
  if (filterData.dateStart)
    filter.filters.push({
      field: 'DateAdded',
      operator: FilterOperator.GreaterThanOrEqual,
      value: filterData.dateStart,
    });
  if (filterData.dateEnd)
    filter.filters.push({
      field: 'DateAdded',
      operator: FilterOperator.LessThanOrEqual,
      value: filterData.dateEnd,
    });

  if (filterData.companyId && filterData.companyId !== 0)
    filter.filters.push({
      field: 'CompanyId',
      operator: FilterOperator.EqualTo,
      value: filterData.companyId,
    });
  return filter;
};
